<template lang="html">
    <div class="news">
        <div class="banner-img">
            <div class="container">
                <div class="banner-detail">
                    <p><span>全医佳</span>一站式医疗设备</p>
                    <!-- <img src="https://static.qyjmed.com/webSite/news/banner-img.png" alt=""> -->
                    <video src="http://qyjmed-static.oss-cn-hangzhou.aliyuncs.com/webSite/news/%E5%85%A8%E5%8C%BB%E4%BD%B3%E8%A7%86%E9%A2%91%E4%BF%AE%E6%94%B9%E7%89%88.mp4" autoplay controls width="600" poster="posterimage.jpg">
                    </video>
                </div>
                <div class="banner-content">
                    <ul>
                        <li @click="headToHWx(index)" v-for="(item,index) in sliceList" :key="index">
                            <div class="banner-box">
                                <div class="img">
                                    <img :src="item.img" alt="">
                                </div>
                                <div class="content">
                                    <p>{{item.date}}</p>
                                    <p>{{item.title}}</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <p>行业资讯</p>
                </div>
            </div>
        </div>
        <div class="news-tab">
            <div @click="show=true" class="tab-box">
                <p :class="{active:show==true}">公司新闻</p>
            </div>
            <div @click='show=false' class="tab-box">
                <p :class="{active:show==false}">行业资讯</p>
            </div>
        </div>
        <div class="message">
            <div class="container">
                <ul v-show='show'>
                    <!-- <li @click="toWx(4)">
                        <div class="message-box">
                            <div class="message-content">
                                <div class="date">
                                    <div class="mooth">
                                        Apr
                                    </div>
                                    <div class="year">
                                        <p>23</p>
                                        <p>2019</p>
                                    </div>
                                </div>
                                <div class="text">
                                    <p>“2019华东地区超声科智能化管理新进展专家研讨会”圆满成功</p>
                                    <p>4月22日，在江苏无锡美丽的太湖江苏全医佳主办了“2019华东地区超声科智能化管理新进展专家研讨会”，此次会议由江苏省医学会超声医学分会主办，南京军区总医院超声科承办，江苏全医佳电子商务有限公司及江苏极安医疗设备有限公司共同协办。</p>
                                </div>
                            </div>
                            <div class="message-img">
                                <img width="100%" src="https://static.qyjmed.com/webSite/news/guild/4.webp" alt="">
                            </div>
                        </div>
                    </li> -->
                    <li @click="toDetail(4)">
                        <div class="message-box">
                            <div class="message-content">
                                <div class="date">
                                    <div class="mooth">
                                        Apr
                                    </div>
                                    <div class="year">
                                        <p>17</p>
                                        <p>2020</p>
                                    </div>
                                </div>
                                <div class="text">
                                    <p>踏青赏春光，不负芳菲四月天</p>
                                    <p>生活不止眼前的苟且，还有诗和远方的田野。工作不止办公楼与宿舍的两点一线，还有丰富多彩的团建...</p>
                                </div>
                            </div>
                            <div class="message-img">
                                <img width="100%" src="http://qyjmed-static.oss-cn-hangzhou.aliyuncs.com/webSite/news/group/7.jpg" alt="">
                            </div>
                        </div>
                    </li>
                    <li @click="toWx(2)">
                        <div class="message-box">
                            <div class="message-content">
                                <div class="date">
                                    <div class="mooth">
                                        Fab
                                    </div>
                                    <div class="year">
                                        <p>15</p>
                                        <p>2020</p>
                                    </div>
                                </div>
                                <div class="text">
                                    <p>全医佳&江苏极安 | 捐赠爱心物资，携手抗击疫情！</p>
                                    <p>现在正是疫情防控的关键时期，对于我们医疗服务企业来说，应以高度的社会责任感和强烈的家国情怀，为疫情防控工作贡献一点自己的微薄之力，展示民营企业的担当，体现我们回馈社会的决心！</p>
                                </div>
                            </div>
                            <div class="message-img">
                                <img width="100%" src="https://static.qyjmed.com/webSite/news/guild/2.webp" alt="">
                            </div>
                        </div>
                    </li>
                    <li @click="toWx(1)">
                        <div class="message-box">
                            <div class="message-content">
                                <div class="date">
                                    <div class="mooth">
                                        Jan
                                    </div>
                                    <div class="year">
                                        <p>01</p>
                                        <p>2020</p>
                                    </div>
                                </div>
                                <div class="text">
                                    <p>喜讯！热烈祝贺江苏极安获得高新技术企业认定</p>
                                    <p>根据国家《高新技术企业认定管理办法》和《高新技术企业认定管理工作指引》的相关规定及逐级审批，江苏极安医疗设备有限公司于近日被认定为国家级高新技术企业，由此正式迈入国家高新技术企业行列。</p>
                                </div>
                            </div>
                            <div class="message-img">
                                <img width="100%" src="https://static.qyjmed.com/webSite/news/guild/xibao.png" alt="">
                            </div>
                        </div>
                    </li>
                    <li @click="toDetail(1)">
                        <div class="message-box">
                            <div class="message-content">
                                <div class="date">
                                    <div class="mooth">
                                        Jan
                                    </div>
                                    <div class="year">
                                        <p>09</p>
                                        <p>2017</p>
                                    </div>
                                </div>
                                <div class="text">
                                    <p>全医佳与彩超服务联盟缔结战略合作 共同打造医疗设备售后服务平台</p>
                                    <p>2017年1月9日江苏全医佳电子商务有限公司携手“彩超技术服务联盟”，在南京紫东国际创意园正式签约，双方成立全医佳彩超合作联盟，有效实现资源信息互补、共享，提高双方的市场竞争力。</p>
                                </div>
                            </div>
                            <div class="message-img">
                                <img width="100%" src="https://static.qyjmed.com/webSite/news/company/1-1.jpg" alt="">
                            </div>
                        </div>
                    </li>
                    <li @click="toDetail(2)">
                        <div class="message-box">
                            <div class="message-content">
                                <div class="date">
                                    <div class="mooth">
                                        Dec
                                    </div>
                                    <div class="year">
                                        <p>01</p>
                                        <p>2016</p>
                                    </div>
                                </div>
                                <div class="text">
                                    <p>北京健康扶贫基金会与全医佳达成战略合作伙伴</p>
                                    <p>2016年12月1日，江苏全医佳电子商务有限公司副总经理谢玉丹来我会签订一站式医疗设备服务平台项目合作协议书，我会执行理事长朱定良、调研部主任秦燕参与了此次合作协议签订会。 江苏全医佳电子商务有限公司是中国为完善医疗设备服务市场而搭建的综合性纯服务类电商平台。现已联合国内上百家医院、1500多家供应商共同建立联盟性行业生态链，利用互联网开拓信息渠道，颠覆传统的服务运营模式。</p>
                                </div>
                            </div>
                            <div class="message-img">
                                <img width="100%" src="https://static.qyjmed.com/webSite/news/company/2.jpg" alt="">
                            </div>
                        </div>
                    </li>
                    <li @click="toDetail(3)">
                        <div class="message-box">
                            <div class="message-content">
                                <div class="date">
                                    <div class="mooth">
                                        Jun
                                    </div>
                                    <div class="year">
                                        <p>26</p>
                                        <p>2016</p>
                                    </div>
                                </div>
                                <div class="text">
                                    <p>互联网+医疗设备质量控制和管理高峰论坛</p>
                                    <p>为认真学习国家最新颁布的医疗器械质量管理的相关法律法规，深入探讨如何将医疗器械使用管理、质量控制及维修管理的各方面工作与互联网技术相结合，提升医疗设备管理效率及使用安全性，由中国医学装备协会及全医佳医疗设备服务平台联合举办的“互联网+医疗设备质量控制和管理高峰论坛”于2016年6月26日在江苏南京圆满召开。</p>
                                </div>
                            </div>
                            <div class="message-img">
                                <img width="100%" src="https://static.qyjmed.com/webSite/news/company/3-1.jpg" alt="">
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-show='!show'>
                    <li @click="toHWx(index)" v-for="(item,index) in array" :key="index">
                        <div class="message-box">
                            <div class="message-content">
                                <div class="date">
                                    <div class="mooth">
                                        {{item.month}}
                                    </div>
                                    <div class="year">
                                        <p>{{item.day}}</p>
                                        <p>{{item.year}}</p>
                                    </div>
                                </div>
                                <div class="text">
                                    <p>{{item.title}}</p>
                                    <p>{{item.content}}</p>
                                </div>
                            </div>
                            <div class="message-img">
                                <img width="100%" :src="item.img" alt="">
                            </div>
                        </div>
                    </li>
                    <!--工具条-->
        			<!-- <el-col :span="24" >
        				<el-pagination
                        style="text-align:center;margin-top:36px;"
                         layout="prev, pager, next"
                         @current-change="handleCurrentChange"
                         :page-size="pageSize" :total="total"  background>
        				</el-pagination>
        			</el-col> -->

                </ul>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
export default {
	name: 'news',
	data() {
		return {
			show: true,
			pageNum: 1,
			total: 10,
			pageSize: 5,
			array: [],
			sliceList: [],
			// guild:[{
			//     month:'May',
			//     day:'10',
			//     year:'2019',
			//     title:'跨国医械巨头，456亿大收购',
			//     content:'国外，3M公司大手笔收购行业巨头 ; 国内，奥美医疗稳居首位，2018年营收超20亿。',
			//     img:'https://static.qyjmed.com/webSite/news/guild/16.jpg',
			//     href:'https://mp.weixin.qq.com/s/OgIptfBwOJq3vAGeTnrh2A',
			//     date:'2019-05-10'
			// },{
			//     month:'May',
			//     day:'22',
			//     year:'2019',
			//     title:'你吃的外卖塑料餐盒竟然是输液袋？细思极恐！',
			//     content:'医疗废物黑产业链久禁难绝',
			//     img:'https://static.qyjmed.com/webSite/news/guild/15.jpg',
			//     href:'https://mp.weixin.qq.com/s/QbDe25QAk0fcjJKyd2m-AA',
			//     date:'2019-05-22'
			// },{
			//     month:'May',
			//     day:'23',
			//     year:'2019',
			//     title:'医药代表薪酬数字公布，还在涨！',
			//     content:'外资药企的员工平均薪酬最高，达120072元，而民营药企最低，仅为76004元；值得注意的是，销售岗的平均年薪129298元——在整个制药行业中，医药代表的薪酬水平仍然保持前列，且保持一定的涨幅。',
			//     img:'https://static.qyjmed.com/webSite/news/guild/14.jpg',
			//     href:'https://mp.weixin.qq.com/s/Ak3vVEoJ1mcOsC2Ibeuiew',
			//     date:'2019-05-23'
			// },{
			//     month:'May',
			//     day:'28',
			//     year:'2019',
			//     title:'国家药监局：5家医械公司问题产品召回！强生、美敦力、西门子...',
			//     content:'近日，国家药品监督管理局发布了多条产品召回公告，公布了一批被召回医疗产品名单。',
			//     img:'https://static.qyjmed.com/webSite/news/guild/13.jpg',
			//     href:'https://mp.weixin.qq.com/s/F2sLcTGgp9KjGygA4KkSgA',
			//     date:'2019-05-28'
			// },{
			//     month:'Jun',
			//     day:'03',
			//     year:'2019',
			//     title:'从3千万做到128亿！药商大亨杀进耗材圈，“两票制”起到重要作用！',
			//     content:'2018年，医械圈风起云涌，多家医药流通巨头跨界医械流通，赚的是盆满钵满。从营收不到3000万，到128亿，从1个省到全国，这家公司仅用了7年时间！',
			//     img:'https://static.qyjmed.com/webSite/news/guild/12.jpg',
			//     href:'https://mp.weixin.qq.com/s/Ikw03oK1KWLvc62FLivCmQ',
			//     date:'2019-06-03'
			// },{
			//     month:'Jun',
			//     day:'05',
			//     year:'2019',
			//     title:'刚刚！国务院重磅文件公布，2019年这两大任务影响所有医械人',
			//     content:'深化医药卫生体制改革2019年重点工作任务公布，两项任务对医疗器械行业影响重大。',
			//     img:'https://static.qyjmed.com/webSite/news/guild/11.jpg',
			//     href:'https://mp.weixin.qq.com/s/UNMxBKN9yFy8J8LlDunGWw',
			//     date:'2019-06-05'
			// },{
			//     month:'Jun',
			//     day:'13',
			//     year:'2019',
			//     title:'超6000万设备大单只要国产！286台全自动生化分析仪...',
			//     content:'2.1亿医疗设备之后，又有超6000万医疗设备只要国产！',
			//     img:'https://static.qyjmed.com/webSite/news/guild/0613.jpg',
			//     href:'https://mp.weixin.qq.com/s/38g_7E9gLuLg_h0kwSbbmw',
			//     date:'2019-06-13'
			// },{
			//     month:'Jun',
			//     day:'17',
			//     year:'2019',
			//     title:'猛增300亿！迈瑞最新市值公布',
			//     content:'106天，迈瑞市值涨了300亿。',
			//     img:'https://static.qyjmed.com/webSite/news/guild/0617.jpg',
			//     href:'https://mp.weixin.qq.com/s/ve0kWELt2Tp0gvg6iGpNuA',
			//     date:'2019-06-17'
			// },{
			//     month:'Jun',
			//     day:'19',
			//     year:'2019',
			//     title:'3万件产品不合格，医械巨头被处罚',
			//     content:'振德医疗3万件医用纱布块不符合标准要求被处罚。',
			//     img:'https://static.qyjmed.com/webSite/news/guild/0619.jpg',
			//     href:'https://mp.weixin.qq.com/s/4BC2ZXVO3EDO6HNsnsPewQ',
			//     date:'2019-06-19'
			// },{
			//     month:'Jun',
			//     day:'21',
			//     year:'2019',
			//     title:'2019，医疗器械流通领域十大变局！经销商你最担忧的是什么？',
			//     content:'然而2019年一开年便是风起云涌。走到2019年年中，医疗器械流通领域又将迎来哪些变化？经销商朋友们你们目前最大的担忧又是什么呢？',
			//     img:'https://static.qyjmed.com/webSite/news/guild/0621.jpg',
			//     href:'https://mp.weixin.qq.com/s/QN8GpATLp6NyK1KoCcgbew',
			//     date:'2019-06-21'
			// },{
			//     month:'Jun',
			//     day:'27',
			//     year:'2019',
			//     title:'4335亿！艾伯维收购艾尔建',
			//     content:'艾伯维作为全球研究型生物制药公司，在全球拥有近25000名员工，产品销往170多个国家。艾伯维中国的产品线涉及多个疾病领域，涵盖免疫学领域、抗病毒学领域、肾脏学领域以及麻醉学领域。',
			//     img:'https://static.qyjmed.com/webSite/news/guild/0627.jpg',
			//     href:'https://mp.weixin.qq.com/s/lZCpcheDqdGhdHrxb5SEtw',
			//     date:'2019-06-27'
			// },{
			//     month:'Jul',
			//     day:'11',
			//     year:'2019',
			//     title:'重磅！一批医疗设备高关税将豁免，涉美敦力等多家械企',
			//     content:'特朗普政府宣布，将豁免从医疗设备到关键电容器等110种中国输美产品的高额关税，一些美企松了口气。',
			//     img:'https://static.qyjmed.com/webSite/news/guild/0711.jpg',
			//     href:'https://mp.weixin.qq.com/s/gLP4lhgBh3Qivk4cKUxKxw',
			//     date:'2019-07-11'
			// }]
		}
	},
	computed: {
		// sliceList: function(){
		//     return this.guild.reverse().slice(0,4)
		// }
	},
	methods: {
		toDetail: function(index) {
			this.$router.push({
				path: './article' + index + ''
			})
		},
		handleCurrentChange(val) {
			this.pageNum = val;
			this.tablePagination();
		},
		tablePagination: function() {
			let array = [],
				startNum = 0,
				endNum = 0;
			this.total = this.guild.length;
			startNum = (this.pageNum - 1) * this.pageSize;
			endNum = this.pageNum * this.pageSize;
			this.array = this.guild.slice(startNum, endNum)
		},
		toWx: function(index) {
			if (index == 1) {
				window.open('https://mp.weixin.qq.com/s/Af6GbfWRN0LsKWBkYvOJUA')
			} else if (index == 2) {
				window.open('https://mp.weixin.qq.com/s/R5iH9vZY2HIq40GezCohaw')
			} else if (index == 3) {
				window.open('https://mp.weixin.qq.com/s/EuUta0n8z8gfx_fsI0zn2Q')
			} else if (index == 4) {
				window.open('https://mp.weixin.qq.com/s/FRXDi7CktcSiqaNArLNnQA')
			}
		},
		toHWx: function(index) {
			window.open(this.array[index].href)
		},
		headToHWx: function(index) {
			window.open(this.sliceList[index].href)
		},
		sliceData: function() {
			this.sliceList = this.guild.reverse().slice(0, 4)
		}
	},
	mounted() {
		this.tablePagination()
		this.sliceData()
	},
	components: {
		Foot
	}
}
</script>

<style lang="scss" scoped>
.news {
    .banner-img {
        margin-top: $highlight-height;
        background: url("https://static.qyjmed.com/webSite/news/bg.png") center;
        height: 550px;
        .banner-detail {
            width: 714px;
            padding-left: 26px;
            display: inline-block;
            vertical-align: top;
            p {
                margin-top: 130px;
                color: white;
                font-size: 25px;
                margin-bottom: 24px;
                margin-left: 120px;
                span {
                    font-size: 38px;
                    margin-right: 20px;
                }
            }
        }
        .banner-content {
            width: 460px;
            height: 550px;
            display: inline-block;
            ul {
                // padding: 147px 22px 0;
                padding: 130px 22px 0;
                li {
                    margin-bottom: 23px;
                    cursor: pointer;
                    .banner-box {
                        .img {
                            height: 70px;
                            display: inline-block;
                            vertical-align: top;
                            img {
                                width: 70px;
                                height: 70px;
                                margin-right: 40px;
                            }
                        }
                        .content {
                            width: 304px;
                            color: white;
                            display: inline-block;
                            p {
                                line-height: 35px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                            }
                        }
                    }
                }
            }
            > p {
                background: #ffffff20;
                color: white;
                padding-right: 20px;
                font-size: 16px;
                line-height: 32px;
                margin-right: 2px;
                text-align: right;
            }
        }
    }
    .news-tab {
        width: 280px;
        margin: 32px auto;
        .tab-box {
            width: 138px;
            display: inline-block;
            border: 1px solid #eee;
            margin-left: -1px;
            cursor: pointer;
            p {
                color: #484848;
                font-size: 20px;
                text-align: center;
                line-height: 50px;
                &.active {
                    background: #F67605;
                    color: white;
                }
            }
        }
    }
    .message {
        // min-height: 600px;
        .container {
            ul {
                margin-bottom: 100px;
                li {
                    div.message-box {
                        cursor: pointer;
                        .message-content {
                            padding: 54px 62px 56px 28px;
                            width: 910px;
                            display: inline-block;
                            border-bottom: 1px dashed #999999;
                            .date {
                                color: #000;
                                display: inline-block;
                                .mooth {
                                    font-size: 40px;
                                    width: 100px;
                                    display: inline-block;
                                    vertical-align: top;
                                }
                                .year {
                                    width: 79px;
                                    font-size: 24px;
                                    line-height: 45px;
                                    display: inline-block;
                                    text-align: center;
                                    border-right: 1px dashed #999999;
                                    p:last-child {
                                        color: #484848;
                                    }
                                }
                            }
                            .text {
                                width: 730px;
                                display: inline-block;
                                p {
                                    padding-left: 58px;
                                    &:first-child {
                                        font-size: 16px;
                                        color: #333;
                                        font-weight: bold;
                                        margin-bottom: 16px;
                                    }
                                    &:last-child {
                                        color: #666;
                                        font-size: 14px;
                                        line-height: 24px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        display: -webkit-box;
                                        -webkit-box-orient: vertical;
                                        -webkit-line-clamp: 2;
                                        min-height: 48px;
                                    }
                                }
                            }
                        }
                        .message-img {
                            width: 200px;
                            display: inline-block;
                        }
                    }
                }
            }
        }
    }
}
</style>
